// extracted by mini-css-extract-plugin
export var banner = "_ds-0";
export var closeButton = "_ds-2";
export var greenCheckmark = "_ds-3";
export var hereLink = "_ds-4";
export var titleIcon = "_ds-1";